import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@mysaiva/core'
import styles from './ApiKeys.module.scss'

interface FormErrorBannerProps {
  title: string
  text: string
  /** A new value re-opens a banner the user dismissed (e.g. the next failed submit). */
  trigger: unknown
  'data-testid'?: string
  'data-failure'?: string
}

/**
 * Compact error banner for the key panels (SAIV-11619): the design system's
 * single-row error alert (pink surface, red outlined icon and text, close
 * button), not antd's tall card alert.
 */
export function FormErrorBanner({ title, text, trigger, ...rest }: FormErrorBannerProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  useEffect(() => {
    setOpen(true)
  }, [trigger])

  if (!open) return null

  return (
    <div className={styles.errorBanner} role="alert" {...rest}>
      <Icon icon="CrossCircle" size={20} className={styles.errorBannerIcon} />
      <p className={styles.errorBannerText}>
        <strong>{title}.</strong> {text}
      </p>
      <button
        type="button"
        className={styles.errorBannerClose}
        onClick={() => setOpen(false)}
        aria-label={t('developerPlatform.apiKeys.dismissError')}
      >
        <Icon icon="Cross" size={16} />
      </button>
    </div>
  )
}
